import axios from "axios";

const API_URL = "https://apirk.drrkvishwakarma.com/api";

// const API_URL = "http://localhost:8081/api";

const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, userData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const forgotPassword = async (userData) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/forgotpassword`,
      userData
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

const loginUser = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, credentials);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const fetchUser = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/auth/getuser`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching user:",
      error.response?.data || error.message
    );
    throw error;
  }
};
const sendOtp = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/otp/send-otp`, {
      email, // dynamically send either email or phone
    });

    if (response) {
      console.log("OTP sent successfully");
      return true; // Indicating OTP was sent successfully
    } else {
      console.error("Failed to send OTP");
      return false;
    }
  } catch (error) {
    console.error("Error sending OTP:", error);
    return false;
  }
};

const validateOtp = async (emailOrPhone, otp, type = "email") => {
  try {
    const response = await axios.post(`${API_URL}/otp/validate-otp`, {
      [type]: emailOrPhone, // dynamically use either email or phone
      otp: otp, // OTP entered by the user
    });
    if (response) {
      console.log("OTP validated successfully");
      return true; // Indicating OTP is valid
    } else {
      console.error("Invalid OTP");
      return false; // OTP is invalid
    }
  } catch (error) {
    console.error("Error validating OTP:", error);
    return false; // Error in OTP validation
  }
};
const addAppointment = async (appointmentData) => {
  try {
    const response = await axios.post(
      `${API_URL}/appointment/add`,
      appointmentData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // Axios automatically parses the response, no need for .json()
    return response.data;
  } catch (error) {
    // Handle errors properly
    throw error.response?.data?.message || "Something went wrong.";
  }
};

const deleteAppointment = async (userId, appointmentId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/appointment/delete/${userId}/${appointmentId}`
    );
    return response;
  } catch (error) {
    console.error("Error:", error.response?.data?.message || error.message);
    alert(error.response?.data?.message || "Failed to delete appointment");
  }
};
export const updateAppointment = async (
  selectedLocation,
  appointmentToEdit,
  newDate,
  selectedTime
) => {
  try {
    const res = await axios.put(`${API_URL}/appointment/update`, {
      selectedLocation,
      appointmentToEdit,
      newDate,
      selectedTime,
    });

    return res.data;
  } catch (err) {
    console.error("Error updating appointment:", err);
    alert("Something went wrong while updating the appointment.");
    return null;
  }
};
export const getConsultation = async () => {
  try {
    const response = await axios.get(`${API_URL}/appointmentfee/all`);
    console.log("Inside Backedn", response);
    return response.data.data;
  } catch (error) {
    console.error(
      "Error fetching remedies:",
      error.response?.data || error.message
    );
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch remedies",
    };
  }
};
export const getAllAppointmentsByEmail = async (email) => {
  try {
    const response = await axios.get(`${API_URL}/auth/getUser/${email}`);
    console.log("Res In Va", response);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching appointments:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getDoctor = async (email) => {
  try {
    const response = await axios.get(
      `${API_URL}/doctor/getdoctoremail/${email}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching doctor:",
      error.response?.data || error.message
    );
    return null;
  }
};
export const getDoctorTimeSlots = async (
  id,
  date,
  location,
  selectedConsultation
) => {
  try {
    const response = await axios.get(
      `${API_URL}/doctor/gettimeslot/${id}/${location}/${selectedConsultation}/${date}` // ✅ location before date
    );
    console.log("Backend Res Doctor time", response);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching doctor time slots:",
      error.response?.data || error.message
    );
    return null;
  }
};
export const getAllDoctors = async () => {
  try {
    const response = await axios.get(`${API_URL}/doctor/getall`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching doctor:",
      error.response?.data || error.message
    );
    return null;
  }
};
export const getDoctorById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/doctor/getdoctor/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching doctor:",
      error.response?.data || error.message
    );
    return null;
  }
};
export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${API_URL}/event/all`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllMembers = async () => {
  try {
    const response = await axios.get(`${API_URL}/team/all`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllTestimonials = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonial/all`);
    console.log("In backend", response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllLocations = async () => {
  try {
    const response = await axios.get(`${API_URL}/location/all`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export {
  registerUser,
  loginUser,
  fetchUser,
  addAppointment,
  // getBookedTimeSlots,
  deleteAppointment,
  sendOtp,
  validateOtp,
  forgotPassword,
};
